import { Steps, StepId } from "./StepDefinitions";

export function getStepIndex(id: StepId): number {
  return Steps.findIndex((s) => s.id === id);
}

export function getNextStep(id: StepId): StepId | null {
  const idx = getStepIndex(id);
  if (idx < 0 || idx >= Steps.length - 1) return null;
  return Steps[idx + 1].id;
}

export function getPrevStep(id: StepId): StepId | null {
  const idx = getStepIndex(id);
  if (idx <= 0) return null;
  return Steps[idx - 1].id;
}

export function isLastStep(id: StepId): boolean {
  return Steps[Steps.length - 1].id === id;
}

export function firstStep(): StepId {
  return Steps[0].id;
}
